export const HomeRouteLink = () => "/";
export const LoginRouteLink = () => "/login";
export const NotFoundRouteLink = () => "*"; // This is a catch-all router that will match any path that is not matched by the other routes.
export const ProjectGlobalLink = () => "/project";
export const CartRouteLink = () => "/cart";
export const ProjectDetailsLink = (projectId) => `${projectId}`;
export const BorrowerRoutLink = () =>
  "https://richard35.aidaform.com/free-course-registration-form";
export const SettingsRouteLink = () => "/settings";
export const InvestmentRouteLink = () => "/investment";
export const BorrowerRouteLink = () => "/";
export const AdminRouteLink = () => "/admin";
export const RedirectRouteLink = () => "/redirect";
export const MyProjectRouteLink = () => "/my-project";
export const BorrowerSettingsRouteLink = () => "/borrower-settings";
export const AdminSettingsRouteLink = () => "/admin-settings";
export const AdminProjectRouteLink = () => "/admin-projects";
export const AdminLenderRouteLink = () => "/admin-lenders";
export const AdminBorrowerRouteLink = () => "/admin-borrows";
export const WalletRouteLink = () => "/wallet";
export const GroupeRouteLink = () => "/group";
